import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// Set Firebase Auth to use local persistence
// This ensures authentication state persists across page refreshes and browser restarts
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase Auth configured for local persistence');
  })
  .catch((error) => {
    console.error('Error setting Firebase Auth persistence:', error);
    // Fallback to default persistence if local persistence fails
    console.log('Falling back to default persistence');
  });

export const db = getFirestore(app);
export const storage = getStorage(app);

/**
 * Get Firebase configuration
 * @returns {Object} Firebase configuration object
 */
export const getFirebaseConfig = () => {
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    apiBaseURL: process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://us-central1-quantumleap-emr-dev.cloudfunctions.net'
  };
};


export default app;
